import { create } from "zustand";
import { TankStoreProps } from "./interface/tank-store.interface";
import { getFilterTankEmissionControl, getFilterTankType, getTankEmissionControl, getTankType } from "src/services/settings.service";

export const tankStore = create<TankStoreProps>((set) => ({
  tankType: [],
  filterTankType: [],
  totalTankType: 0,
  tankEmissionControl: [],
  filterTankEmissionControl: [],
  totalTankEmissionControl: 0,
  getTankType: async (query: string) => {
    try {
      const response = await getTankType(query);
      set(() => ({
        tankType: response.data?.data.data ?? [],
        totalTankType: response.data?.data.total ?? 0,
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  getFilterTankType: async () => {
    try {
      const response = await getFilterTankType();
      set(() => ({
        filterTankType: response.data.data.filter ?? [],
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  getTankEmissionControl: async (query: string) => {
    try {
      const response = await getTankEmissionControl(query);
      set(() => ({
        tankEmissionControl: response.data?.data.data ?? [],
        totalTankEmissionControl: response.data?.data.total ?? 0,
      }));
    } catch (error) {
      console.error(error);
    }
  },
  getFilterTankEmissionControl: async () => {
    try {
      const response = await getFilterTankEmissionControl();
      set(() => ({
        filterTankEmissionControl: response.data.data.filter ?? [],
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
}));
